import React from 'react'

const BannerLandingActivities = (props) => (
    <section id="banner" className="style2">
        <div className="inner">
            <header className="major">
                <h1>Activities</h1>
            </header>
            <div className="content">
                <h2>Timeline and donors</h2>
            </div>
        </div>
    </section>
)

export default BannerLandingActivities



// WEBPACK FOOTER //
// ./src/components/BannerLandingActivities.js